import { BeamIcon, ColumnIcon } from 'assets/orientations';
import { SvgIconSet } from 'shared/types';

export const ORIENTATION_ICONS: SvgIconSet = {
  Column: <ColumnIcon />,
  Beam: <BeamIcon />,
};
